import request from "@/utils/request";
import {AllocationState, IAddShippingModel, IDefaultShippingOrderModel} from "./types";

export const saveShippingData: IAddShippingModel = {
  id: null,
  shippingCode: null,
  sellerId: null,
  customerId: null,
  code: null,
  name: null,
  abbreviation: null,
  customerAddress: null,
  tel: null,
  country: null,
  departures: null,
  tradeCountry: null,
  departure: null,
  transportation: null,
  destinationCountry: null,
  deliveryCountry: null,
  portDischarge: null,
  internationalTradeTerms: null,
  payment: null,
  paymentDetails: null,
  ladingType: null,
  notifier: null,
  notifierAddress: null,
  startDate: null,
  combinedContainer: null
};

export const defaultShippingData: IDefaultShippingOrderModel = {
  id: null,
  shippingCode: null,
  abbreviation: null,
  startDate: null,
  inShippingSpaceState: null,
  billLadingCode: null,
  containerTypeList: null,
  boxNumber: null,
  sealNo: null,
  allocationStatus: null,
  generatedCustomsDeclarationContract: null,
  bookingOrderCodes: null
};


export const creatShipping = (data: any) =>
  request({
    url: "/shipping-orders",
    method: "post",
    data
  });

export const getShippingOrders = (customerId?: string, company?: string) =>
  request({
    url: "/shipping-orders/options",
    method: "get",
    params: { customerId ,company}
  });

export const searchShippingOrder = (params: any) =>
  request({
    url: "/shipping-orders",
    method: "get",
    params
  });

export const getShippingOrderStatus = () =>
  request({
    url: "/shipping-orders/status",
    method: "get"
  });

export const deleteShippingOrderContainerType = (id: string) =>
  request({
    url: `/shipping-orders/container-types/${id}`,
    method: "DELETE"
  });

export const updateShippingOrderContainerType = (shippingOrderId: string, data: any) =>
  request({
    url: `/shipping-orders/${shippingOrderId}/container-types`,
    method: "PUT",
    data
  });
  export const saveContainerType = (data: any) =>
  request({
    url: `/container-types`,
    method: "PUT",
    data
  });

export const createShippingOrderContainerType = (id: string, data: any) =>
  request({
    url: `/shipping-orders/${id}/container-types`,
    method: "post",
    data
  });

export const confirmPutShipping = (id: string, data: any) =>
  request({
    url: `/shipping-orders/${id}/confirmation`,
    method: "put",
    data
  });

export const getShippingOrderContainerTypeReleasedInfo = (shippingOrderId: string, params: { loadingPlanId: string, type: string }) =>
  request({
    url: `/shipping-orders/${shippingOrderId}/container-type/released-infos`,
    method: "GET",
    params
  });

export const batchDeleteShippingOrders = (ids: string[]) =>
  request({
    url: `/shipping-orders`,
    method: "DELETE",
    data: { ids: ids }
  });

export const getShippingOrderByCustomerIdAndNoReleasedToBookingOrder = (params:{shippingOrderCodeKeyWord: string} ) =>
    request({
        url: `/shipping-orders/unrelated-to-booking-order`,
        method: "GET",
        params
    })
export const getCustomerInfoAndCompany = (id: string) =>
    request({
        url: `/shipping-orders/${id}/customer-info`,
        method:"GET"
    })

// /shipping-orders/{id}/remark
export const updateRemark = (id: string, remark: string) =>
    request({
        url: `/shipping-orders/${id}/remark`,
        method:"PUT",
        data:{
          remark: remark
      }
    })

// /shipping-orders/{id}/bill-lading-code
export const updateBillLadingCode = (id: string, billLadingCode: string) =>
    request({
        url: `/shipping-orders/${id}/bill-lading-code?code=${billLadingCode}`,
        method:"PUT"
    })

// /shipping-orders/{id}
export const queryDetail = (id: string) =>
    request({
        url: `/shipping-orders/${id}`,
        method:"GET"
    })

/** 订舱号预览（选客人后按公司+客人生成） */
export const shippingOrderCodePreview = (params: {
  company: string;
  customerId: string;
}) =>
  request({
    url: `/shipping-orders/preview-code`,
    method: "GET",
    params,
  });

